export default __webpack_public_path__ + "static/media/faq.02d52698.png";